import { environment } from "./environment";

export const AppConfig = {
    apiURL: environment.apiURL,
    versionCode: 'v0.0.1'
}